<div class="bg-surface-elevated text-text-primary relative overflow-hidden"
      style="background-image: url('pexels-expect-best-79873-323780.jpg'); background-size: cover; background-position: center;">

      <!-- Dark overlay for readability -->
      <div class="absolute inset-0 bg-bg-base/70 z-0 pointer-events-none"></div>

      <!-- Glow effect -->
      <div class="absolute -right-40 -top-40 h-80 w-80 rounded-full bg-primary/5 blur-3xl pointer-events-none z-0">
      </div>

      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">

            <!-- Header -->
            <div>
                  <h1 class="text-3xl font-bold mb-2 text-text-primary">{{ 'seekerDashboard.header.title' | translate }}
                  </h1>
                  <p class="text-text-secondary mb-8 max-w-3xl">{{ 'seekerDashboard.header.subtitle' | translate }}</p>

                  <!-- Overview Stats -->
                  <div class="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">

                        <!-- Properties Owned -->
                        <div
                              class="bg-surface/75 backdrop-blur-md border border-border-strong rounded-xl p-4 text-center hover:-translate-y-1 transition duration-300 group hover:border-primary/50 hover:bg-surface-hover shadow-elevated">
                              <div class="flex justify-center mb-3">
                                    <div
                                          class="w-10 h-10 bg-surface-elevated rounded-lg flex items-center justify-center border border-border group-hover:border-primary/30 transition-colors shadow-inner">
                                          <i
                                                class="fa-solid fa-building text-lg text-text-secondary group-hover:text-primary transition-colors"></i>
                                    </div>
                              </div>
                              <div class="text-2xl font-semibold mb-1 text-text-primary">
                                    <ng-container *ngIf="!loading">{{ overview.propertiesOwned }}</ng-container>
                                    <ng-container *ngIf="loading"><i
                                                class="fa-solid fa-circle-notch fa-spin text-base text-primary"></i></ng-container>
                              </div>
                              <div class="text-text-muted text-xs uppercase tracking-wider font-mono font-semibold">{{
                                    'seekerDashboard.header.propertiesOwned' | translate
                                    }}</div>
                        </div>

                        <!-- Properties Rented -->
                        <div
                              class="bg-surface/75 backdrop-blur-md border border-border-strong rounded-xl p-4 text-center hover:-translate-y-1 transition duration-300 group hover:border-primary/50 hover:bg-surface-hover shadow-elevated">
                              <div class="flex justify-center mb-3">
                                    <div
                                          class="w-10 h-10 bg-surface-elevated rounded-lg flex items-center justify-center border border-border group-hover:border-primary/30 transition-colors shadow-inner">
                                          <i
                                                class="fa-solid fa-house text-lg text-text-secondary group-hover:text-primary transition-colors"></i>
                                    </div>
                              </div>
                              <div class="text-2xl font-semibold mb-1 text-text-primary">
                                    <ng-container *ngIf="!loading">{{ overview.propertiesRented }}</ng-container>
                                    <ng-container *ngIf="loading"><i
                                                class="fa-solid fa-circle-notch fa-spin text-base text-primary"></i></ng-container>
                              </div>
                              <div class="text-text-muted text-xs uppercase tracking-wider font-mono font-semibold">{{
                                    'seekerDashboard.header.propertiesRented' |
                                    translate }}</div>
                        </div>

                        <!-- Pending Installments -->
                        <div
                              class="bg-surface/75 backdrop-blur-md border border-border-strong rounded-xl p-4 text-center hover:-translate-y-1 transition duration-300 group hover:border-primary/50 hover:bg-surface-hover shadow-elevated">
                              <div class="flex justify-center mb-3">
                                    <div
                                          class="w-10 h-10 bg-surface-elevated rounded-lg flex items-center justify-center border border-border group-hover:border-primary/30 transition-colors shadow-inner">
                                          <i
                                                class="fa-solid fa-clock text-lg text-text-secondary group-hover:text-primary transition-colors"></i>
                                    </div>
                              </div>
                              <div class="text-2xl font-semibold mb-1 text-text-primary">
                                    <ng-container *ngIf="!loading">{{ overview.pendingInstallments }}</ng-container>
                                    <ng-container *ngIf="loading"><i
                                                class="fa-solid fa-circle-notch fa-spin text-base text-primary"></i></ng-container>
                              </div>
                              <div class="text-text-muted text-xs uppercase tracking-wider font-mono font-semibold">{{
                                    'seekerDashboard.header.pendingInstallments' |
                                    translate }}</div>
                        </div>

                        <!-- Overdue Installments -->
                        <div class="backdrop-blur-md border rounded-2xl p-4 text-center hover:-translate-y-1 transition duration-300 group shadow-lg"
                              [ngClass]="{'border-danger/40 bg-danger-soft hover:border-danger/60': !loading && overview.overdueInstallments > 0, 'bg-surface/75 border-border-strong hover:border-primary/50 hover:bg-surface-hover': !(!loading && overview.overdueInstallments > 0)}">
                              <div class="flex justify-center mb-3">
                                    <div class="w-10 h-10 rounded-xl flex items-center justify-center border transition-colors shadow-inner"
                                          [ngClass]="{'bg-danger-soft border-danger/40 group-hover:border-danger/60': !loading && overview.overdueInstallments > 0, 'bg-surface-elevated border-border group-hover:border-primary/30': !(!loading && overview.overdueInstallments > 0)}">
                                          <i class="fa-solid fa-triangle-exclamation text-lg transition-colors"
                                                [ngClass]="{'text-danger': !loading && overview.overdueInstallments > 0, 'text-text-secondary group-hover:text-primary': !(!loading && overview.overdueInstallments > 0)}"></i>
                                    </div>
                              </div>
                              <div class="text-2xl font-semibold mb-1 shadow-text"
                                    [ngClass]="{'text-danger': !loading && overview.overdueInstallments > 0, 'text-text-primary': !(!loading && overview.overdueInstallments > 0)}">
                                    <ng-container *ngIf="!loading">{{ overview.overdueInstallments }}</ng-container>
                                    <ng-container *ngIf="loading"><i
                                                class="fa-solid fa-circle-notch fa-spin text-base text-primary"></i></ng-container>
                              </div>
                              <div class="text-xs uppercase tracking-wider font-mono font-semibold"
                                    [ngClass]="{'text-danger': !loading && overview.overdueInstallments > 0, 'text-text-muted': !(!loading && overview.overdueInstallments > 0)}">
                                    {{ 'seekerDashboard.header.overdueInstallments' | translate }}
                              </div>
                        </div>

                        <!-- Open Support Tickets -->
                        <div
                              class="bg-surface/75 backdrop-blur-md border border-border-strong rounded-xl p-4 text-center hover:-translate-y-1 transition duration-300 group hover:border-primary/50 hover:bg-surface-hover shadow-elevated">
                              <div class="flex justify-center mb-3">
                                    <div
                                          class="w-10 h-10 bg-surface-elevated rounded-lg flex items-center justify-center border border-border group-hover:border-primary/30 transition-colors shadow-inner">
                                          <i
                                                class="fa-solid fa-headset text-lg text-text-secondary group-hover:text-primary transition-colors"></i>
                                    </div>
                              </div>
                              <div class="text-2xl font-semibold mb-1 text-text-primary">
                                    <ng-container *ngIf="!loading">{{ overview.openSupportTickets }}</ng-container>
                                    <ng-container *ngIf="loading"><i
                                                class="fa-solid fa-circle-notch fa-spin text-base text-primary"></i></ng-container>
                              </div>
                              <div class="text-text-muted text-xs uppercase tracking-wider font-mono font-semibold">{{
                                    'seekerDashboard.header.supportTickets' | translate
                                    }}</div>
                        </div>

                  </div>

            </div>
      </div>
</div>
